import {
	Acl,
	ShareBaseLibrary,
	ShareBaseFolder,
	PermissionType
} from 'phoenix/domain';
import { 
	IUriPathService, 
	PhoenixToggleService 
} from 'phoenix/services'
import { default as SettingsService} from 'phoenix/services/settingsService'


/**
* @ngdoc service
* @name  sharebase.sbLibraryService
* 
* @description 
* A service used to retrieve and interact with ShareBase
* libraries
* 
**/
export class LibraryService {
	public static $inject = [
		'$q',
		'$http',
		'pxUriPathService',
		'settingsService',
		'pxPhoenixToggleService'
	]

	public requestPermissions(lirbary:ShareBaseLibrary, perms:PermissionType) {
		return this.$q.reject(new Error('Not implemented')) as ng.IHttpPromise<void>;
	}

	constructor(
		private $q:ng.IQService,
		private $http:ng.IHttpService,
		private pxUriPathService:IUriPathService,
		private settingsService:SettingsService,
		private pxPhoenixToggleService:PhoenixToggleService
	){
	}

	public getUserLibrary() {
		return this
			.getLibraries()
			.then(this.selectUsersLibrary);
	}

	public getLibraries() {
		//TODO: remove the /home call when 'home-endpoint-v2' feature toggle is turned on
		return this.pxPhoenixToggleService.isEnabled('home-endpoint-v2')
			.then((isEnabled) => {
				let homeEndpoint = isEnabled ? '/home-v2' : '/home';				 
				return this.$http
				.get(this.settingsService.serverAPIPath + homeEndpoint)
				.then(response => (response.data as any).Embedded.Libraries as ShareBaseLibrary[]);
			});
	}

	public selectUsersLibrary(libs) {
		let userLib = null;

		for (var i = 0; i < libs.length; i++) {
			if (libs[i].IsPrivate) {
				userLib = libs[i];
				break;
			}
		}

		return userLib as ShareBaseLibrary;
	}

	public getLibraryFolders(library) {
		return this.$http
			.get(library.Links.RootFoldersUri)
			.then(response => response.data as ShareBaseFolder[]);
	}

	public createFolder(libraryID, name) {
		return this.$http
			.post(this.settingsService.serverAPIPath + '/libraries/' + libraryID + '/folders', {FolderName: name})
			.then(response => response.data as ShareBaseFolder);
	}

	public getPermissionsForCurrentUser(libraryId) {
		let uri = this.pxUriPathService.resolvePath('/libraries/{id}/permissionsforuser', {
			id: libraryId
		});

		return this.$http
			.get(uri)
			.then(response => response.data as Acl[]);
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/services/libraryService.ts